export default __webpack_public_path__ + "static/media/element_spec_13.74c7d35a.webp";